module.exports = __webpack_public_path__ + "media/components/CopyToClipboard/copyIcon-f562093d834e3d1899b40c5b9bdb42b9.svg";